import { Actions } from './static-content-templates.actions'
import { fromJS } from 'immutable'
import * as StaticContentTemplatesTypes from './static-content-templates.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 10,
    },
    total: 0,
    results: 0,
  },
  updateStaticContentTemplate: {
    isLoading: false,
    isUploading: false,
    validationErrors: {},
    data: {},
  },
})

export function staticContentTemplatesReducer(
  state = initialState,
  action: Actions,
) {
  switch (action.type) {
    case StaticContentTemplatesTypes.UPDATE_STATIC_CONTENT_TEMPLATE_REQUEST: {
      return state
        .setIn(['updateStaticContentTemplate', 'isLoading'], true)
        .setIn(['updateStaticContentTemplate', 'validationErrors'], fromJS({}))
    }

    case StaticContentTemplatesTypes.UPDATE_STATIC_CONTENT_TEMPLATE_SUCCESS: {
      return state.setIn(['updateStaticContentTemplate', 'isLoading'], false)
    }

    case StaticContentTemplatesTypes.UPDATE_STATIC_CONTENT_TEMPLATE_FAILURE: {
      return state.setIn(['updateStaticContentTemplate', 'isLoading'], false)
    }

    case StaticContentTemplatesTypes.DELETE_STATIC_CONTENT_TEMPLATE_REQUEST: {
      return state
    }

    case StaticContentTemplatesTypes.DELETE_STATIC_CONTENT_TEMPLATE_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case StaticContentTemplatesTypes.DELETE_STATIC_CONTENT_TEMPLATE_FAILURE: {
      return state
    }

    case StaticContentTemplatesTypes.FETCH_STATIC_CONTENT_TEMPLATES_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case StaticContentTemplatesTypes.FETCH_STATIC_CONTENT_TEMPLATES_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
    }

    case StaticContentTemplatesTypes.FETCH_STATIC_CONTENT_TEMPLATES_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case StaticContentTemplatesTypes.FETCH_STATIC_CONTENT_TEMPLATE_REQUEST: {
      return state.setIn(['updateStaticContentTemplate', 'isLoading'], true)
    }

    case StaticContentTemplatesTypes.FETCH_STATIC_CONTENT_TEMPLATE_SUCCESS: {
      return state
        .setIn(['updateStaticContentTemplate', 'isLoading'], false)
        .setIn(['updateStaticContentTemplate', 'data'], fromJS(action.payload))
    }

    case StaticContentTemplatesTypes.FETCH_STATIC_CONTENT_TEMPLATE_FAILURE: {
      return state.setIn(['updateStaticContentTemplate', 'isLoading'], false)
    }

    case StaticContentTemplatesTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case StaticContentTemplatesTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
